import type { BudgetStatus, Confidence, VelocitySource } from '../api/client.js';

/** Short labels for the confidence badge, and the tone class for each. */
export const CONFIDENCE_LABEL: Record<Confidence, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const CONFIDENCE_CLASS: Record<Confidence, string> = {
  high: 'bg-ok-bg text-ok-text ring-ok-line',
  medium: 'bg-warn-bg text-warn-text ring-warn-line',
  low: 'bg-danger-bg text-danger-text ring-danger-line',
};

/** Short labels and full tooltips for where a SKU's velocity came from. */
export const VELOCITY_SOURCE_LABEL: Record<VelocitySource, string> = {
  own_in_stock: 'In-stock',
  own_monthly: 'Monthly',
  family_mix: 'Family mix',
  seasonal: 'Last year',
  none: 'None',
};

export const VELOCITY_SOURCE_FULL: Record<VelocitySource, string> = {
  own_in_stock: "The SKU's own units per 30 in-stock days.",
  own_monthly: "The SKU's own average units per active month (no in-stock history).",
  family_mix:
    "Borrowed from the family's velocity, split by this SKU's unit share (low confidence).",
  seasonal: "Last year's rate over the same calendar window, scaled by this year's trend.",
  none: 'No sales velocity to project from.',
};

/** Labels and tones for the budget's verdict on a line. */
export const BUDGET_STATUS_LABEL: Record<BudgetStatus, string> = {
  funded: 'Funded',
  partial: 'Partial',
  cut: 'Cut',
  held: 'Review',
  uncosted: 'No cost',
};

export const BUDGET_STATUS_CLASS: Record<BudgetStatus, string> = {
  funded: 'bg-ok-bg text-ok-text ring-ok-line',
  partial: 'bg-warn-bg text-warn-text ring-warn-line',
  cut: 'bg-danger-bg text-danger-text ring-danger-line',
  held: 'bg-warn-bg text-warn-text ring-warn-line',
  uncosted: 'bg-sunken text-muted ring-line-strong',
};
